var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.77759 19.3199v-6.4061c0-1.0108.81945-1.8303 1.8303-1.8303h10.98181c1.0109 0 1.8303.8195 1.8303 1.8303v6.4061c0 1.0108-.8194 1.8303-1.8303 1.8303h-10.98181c-1.01085 0-1.8303-.8195-1.8303-1.8303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.60791 11.0834v-2.74545c0-3.03254 2.45837-5.4909 5.49089-5.4909 3.0326 0 5.4909 2.45836 5.4909 5.4909v2.74545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15v2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.476f7635be45d8158824173d4520d33e.svg";
export { ForwardRef as ReactComponent };